import amex from "@/assets/images/payment/amex.png"
import diners from "@/assets/images/payment/diner.png"
import discover from "@/assets/images/payment/discover.png"
import jcb from "@/assets/images/payment/jcb.png"
import mastercard from "@/assets/images/payment/mastercard.png"
import visa from "@/assets/images/payment/visa.png"

export const CREDIT_CARD_ASSETS = {
  amex: amex,
  diners: diners,
  discover: discover,
  jcb: jcb,
  mastercard: mastercard,
  visa: visa,
}

export const CREDIT_CARD_NAME = {
  amex: "American Express",
  diners: "Diners Club",
  discover: "Discover",
  jcb: "JCB",
  mastercard: "Mastercard",
  visa: "VISA",
}

export const PRODUCT_TYPE = {
  MEMBERSHIP_SUBSCRIPTION: "MEMBERSHIP_SUBSCRIPTION",
  MEMBERSHIP_TRIAL: "MEMBERSHIP_TRIAL",
  COACH_SUBSCRIPTION: "COACH_SUBSCRIPTION",
  POINT_PURCHASE: "POINT_PURCHASE",
  GIFT_PURCHASE: "GIFT_PURCHASE",
}

export const PAYMENT_FAIL_REASON = {
  CARD_TRIAL_INELIGIBLE: "card_trial_ineligible",
}



// WEBPACK FOOTER //
// ./src/constants/payment.js